import React, { PureComponent, Component } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Modal } from 'antd';
import './index.less';
// 画廊，展示多张图片
class ShowImg extends (PureComponent || Component) {
  state = {
  	visible: false,
  	maxHeight: 800,
  	maxWidth: 1000
  };

  showModal = () => {
  	this.setState({
  		visible: true,
  	});
  }

  handleOk = () => {
  	this.setState({
  		visible: false
  	});
  }

  handleCancel = () => {
  	this.setState({
  		visible: false,
  	});
  }

  componentWillMount () {
  	const maxHeight = window.innerHeight * 0.8;
  	const maxWidth = window.innerWidth * 0.8;
  	this.setState({
  		maxHeight: maxHeight,
  		maxWidth: maxWidth
  	});
  }

  render () {
  	const { visible, maxHeight, maxWidth } = this.state;
  	return (
  		<div>
  			<Modal
  				title="Basic Modal"
  				visible={visible}
  				className="showBigImg-modal"
  			>
  				<span className='big-img-close' onClick={this.handleCancel} ><CloseOutlined /></span>
  				<img style={{ maxWidth: maxWidth, maxHeight: maxHeight }} src={this.props.imgSrc} alt="can't load" />
  			</Modal>
  			<div className="gallery-list" onClick={this.showModal}>
  				<img src={this.props.imgSrc} alt="can't load" />
  			</div>
  		</div>
  	);
  }
}

export default ShowImg;
